import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { formatters } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export type TooltipHeaderProps = {
  tooltipTitle: ReactNode;
  filterHintText?: string | null;
  total?: number;
  averageText?: string;
  averageUnitLabel?: string;
};

export const TooltipHeader = ({ tooltipTitle, filterHintText, total, averageText }: TooltipHeaderProps) => {
  const { t } = useTranslation('analytics');

  return (
    <div
      css={{
        alignItems: 'flex-start',
        display: 'flex',
        gap: theme.spacing(3),
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Text size='medium'>{tooltipTitle}</Text>
        {filterHintText ? (
          <Text color='subdued' size='small' css={{ fontStyle: 'italic' }}>
            {filterHintText}
          </Text>
        ) : null}
      </div>
      <div
        css={{
          alignItems: 'flex-end',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {total !== undefined && (
          <Text as='span' color='default' size='medium'>
            {t('Total')} <strong>{formatters.value(total)}</strong>
          </Text>
        )}
        {averageText && (
          <Text color='subdued' size='small' css={{ fontStyle: 'italic' }}>
            {averageText}
          </Text>
        )}
      </div>
    </div>
  );
};
